import { render, staticRenderFns } from "./MyPdf.vue?vue&type=template&id=33755e50"
import script from "./MyPdf.vue?vue&type=script&lang=js"
export * from "./MyPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports